// extracted by mini-css-extract-plugin
export default {"notFoundContainer":"NotFound_notFoundContainer__42UmE","notFoundIcon":"NotFound_notFoundIcon__bqSAc","noReservations":"NotFound_noReservations__OjZ8J"};